// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
const useStylesForApplicationToolBar = makeThemedStyles(
  "ApplicationToolBar",
  (theme) => ({
    ApplicationToolBar: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
    },
  })
);
type ElementProps = React.ComponentProps<
  React.HTMLFactory<HTMLElementTagNameMap["div"]>
>;
export const ApplicationToolBar: React.FunctionComponent<ElementProps> = (
  props: ElementProps
) => {
  const styles = useStylesForApplicationToolBar();
  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.ApplicationToolBar)}
    >
      {props?.children}
    </div>
  );
};
export default ApplicationToolBar;
